import { Modal, TitleBar } from '@shopify/app-bridge-react';

const RepeatScanDialog = ({ shopify, quantity, focusScanArea }) => {
  return(
    <Modal id="repeat-modal" variant="large">
      <div className="modal-body">
        <p style={{ 'color': '#8e1f0b' }}>
          The scanned item is in this order, but may have already been picked. Please confirm this quantity:
        </p>
        <p>
          { quantity }
        </p>
      </div>
      <TitleBar title="Repeat Item">
        <button className="repeat-confirm" variant="primary" onClick={() => shopify.modal.hide('repeat-modal')}>Confirm</button>
      </TitleBar>
    </Modal>
  )
}

export default RepeatScanDialog;
